import * as React from "react"

function ReadMoreCross(props) {
  return (
    <svg
      className="w-4 h-4 lg:w-5 lg:h-5 pb-[5px] lg:pb-[6px] group-hover:rotate-45 transition-transform origin-center duration-300"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 13V1M7 13V1M1 7h12M1 7h12"
        stroke="#0C1414"
        strokeWidth={2}
        strokeLinecap="square"
      />
    </svg>
  )
}

export default ReadMoreCross
